'use client';

import React from 'react';
import Link from 'next/link';

export default function CTASection() {
  return (
    <section className="py-20 px-4 sm:px-6 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 relative overflow-hidden" id="cta">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-blue-500/30 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-blue-800/40 blur-3xl" />
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 border border-white/25 text-white text-xs font-semibold mb-6 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-green-400" />
          </span>
          No credit card · No queue · Start immediately
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
          Build Your Resume —{' '}
          <span className="text-blue-200">Right Now</span>
        </h2>
        <p className="text-base sm:text-lg text-blue-100 mb-10 max-w-lg mx-auto">
          Enter your information, choose a template, get AI suggestions on your existing content, run an ATS check, and export a PDF — all in one place.
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 max-w-md mx-auto border border-white/20">
          <Link
            href="/register"
            className="w-full flex items-center justify-center gap-2 py-4 rounded-xl bg-white text-blue-700 font-bold text-base hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z" />
            </svg>
            Get Started Free
          </Link>

          <div className="mt-3 grid grid-cols-2 gap-2">
            <Link href="/scholarships" className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white/15 text-white text-sm font-medium border border-white/25 hover:bg-white/25 transition-all">
              🎓 Scholarships
            </Link>
            <Link href="/career-search" className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white/15 text-white text-sm font-medium border border-white/25 hover:bg-white/25 transition-all">
              🤖 Career AI
            </Link>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-3 text-xs text-blue-100">
            {[
              { icon: '✦', text: 'Enter your own information' },
              { icon: '✦', text: 'Choose from 3 templates' },
              { icon: '✦', text: 'AI improves your content' },
              { icon: '✦', text: 'Export as PDF' },
            ]?.map(item => (
              <div key={item?.text} className="flex items-center gap-1.5">
                <span className="text-blue-300">{item?.icon}</span>
                <span>{item?.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}